import { EncryptionActionTypes, TCryptoAction } from '@/store/types/encryption.types';
import { IPairKey } from '@/store/models/encryption.model';

export const setGlobalSupportKeys = (globalSupportPairKey: IPairKey): TCryptoAction => ({
  type: EncryptionActionTypes.SET_GLOBAL_SUPPORT_PAIR_KEY,
  globalSupportPairKey,
});

export const setSupportUserKeys = (supportUserPairKey: IPairKey): TCryptoAction => ({
  type: EncryptionActionTypes.SET_SUPPORT_USER_PAIR_KEY,
  supportUserPairKey,
});

export const addUserKeys = (userId: number, userPairKey: IPairKey): TCryptoAction => ({
  type: EncryptionActionTypes.ADD_USER_PAIR_KEY,
  userId,
  userPairKey,
});
